module.exports = __webpack_public_path__ + "static/Banner-4-37a44d9384e58770a1d2ef200c949548.png";